import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { startAnalytics } from './lib/analytics.ts';
import { refetchOnSanction } from './lib/queries.ts';
import { initRuntime } from './lib/runtime.ts';
import { makeRouter } from './router.tsx';
import './styles.css';

await initRuntime();
startAnalytics();
const onError = (err: unknown) => refetchOnSanction(queryClient, err);
const queryClient: QueryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 5_000 } },
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
});
const router = makeRouter(queryClient);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
